import { ToastContainer } from 'react-toastify';

/**
 * 5s em vez de 4s: 4 não davam para ler um motivo de recusa e decidir o que
 * fazer. O limite de 3 evita a pilha que cobre a interface quando várias
 * chamadas falham juntas — o resto entra na fila em vez de empilhar.
 */
const Toastify = () => (
  <ToastContainer
    position="top-right"
    autoClose={5000}
    limit={3}
    pauseOnFocusLoss
    pauseOnHover
    closeOnClick
  />
);

export default Toastify;
